'use client'

import { Fragment } from 'react'
import dynamic from 'next/dynamic'
import { useOptimistic } from 'next-sanity/hooks'
import { createDataAttribute } from 'next-sanity'

const ProjectCredits = dynamic(() => import('@/components/ProjectCredits'))
const ProjectTextBlock = dynamic(() => import('@/components/ProjectTextBlock'))
const Pullquote = dynamic(() => import('@/components/Pullquote'))
const ProjectMedia = dynamic(() => import('@/components/ProjectMedia'))
const ImageCarousel = dynamic(() => import('@/components/ImageCarousel'))
const TypeTesterBlock = dynamic(() => import('@/components/TypeTesterBlock'))
const CharacterSetBlock = dynamic(() => import('@/components/CharacterSetBlock'))

interface ProjectContentBlocksProps {
	contentBlocks: any[]
	documentId: string
}

export default function ProjectContentBlocks({ contentBlocks, documentId }: ProjectContentBlocksProps) {
	const blocks = useOptimistic(contentBlocks, (state: any, action: any) => {
		if (action.id === documentId) {
			return action?.document?.contentBlocks?.map(
				(block: any) => state?.find((s: any) => s._key === block?._key) || block
			)
		}
		return state
	})

	return (
		<div className="section my-section--sm px-site">
			<div
				className="site-grid gap-y-section--sm"
				data-sanity={createDataAttribute({
					id: documentId,
					type: 'project',
					path: "contentBlocks",
				}).toString()}
			>
				{blocks?.map((block) => (
					<Fragment key={block?._key}>
						{block?._type === 'projectCredits' && <ProjectCredits {...block} documentId={documentId} />}

						{block?._type === 'textBlock' && <ProjectTextBlock {...block} documentId={documentId} />}

						{block?._type === 'pullquote' && <Pullquote {...block} documentId={documentId} />}

						{block?._type === 'projectMedia' && <ProjectMedia {...block} documentId={documentId} />}

						{block?._type === 'imageCarousel' && <ImageCarousel {...block} documentId={documentId} />}

						{block?._type === 'typeTester' && <TypeTesterBlock {...block} documentId={documentId} />}

						{block?._type === 'characterSet' && <CharacterSetBlock {...block} documentId={documentId} />}
					</Fragment>
				))}
			</div>
		</div>
	)
}
